import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { fmtKES } from "@/lib/format";

const ZONES = [
  { id: "left_chest", label: "Left Chest", note: "League Sponsor (Default)", x: "12%", y: "22%", w: "20%", h: "16%" },
  { id: "right_chest", label: "Right Chest", note: "Team Logo (Default)", x: "68%", y: "22%", w: "20%", h: "16%" },
  { id: "sleeve", label: "Sleeve", note: "Mara Padel League Logo", x: "0%", y: "30%", w: "10%", h: "20%" },
  { id: "back", label: "Back", note: "8\" Reserved", x: "35%", y: "45%", w: "30%", h: "30%" },
  { id: "jersey", label: "Jersey Body", note: "Unlimited Team Sponsors", x: "20%", y: "65%", w: "60%", h: "22%" },
];

export default function Jerseys() {
  const [sponsors, setSponsors] = useState([]);
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    (async () => {
      const [s, c] = await Promise.all([api.get("/sponsors"), api.get("/config")]);
      setSponsors(s.data);
      setCfg(c.data);
    })();
  }, []);

  const byZone = (id) => sponsors.filter((s) => s.placement === id);

  return (
    <div className="p-6 md:p-10 max-w-6xl">
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Module 3 · Branding Matrix</div>
        <h1 className="font-anton text-5xl md:text-6xl uppercase tracking-tighter text-white">Team Jersey</h1>
      </div>
      <Card className="p-6 bg-[#11241b] border-white/10">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Jersey illustration */}
          <div className="relative aspect-[3/4] rounded-xl border border-white/10 bg-gradient-to-br from-zinc-800 to-zinc-900 overflow-hidden">
            <div className="absolute inset-0">
              {/* Stylized jersey shape using SVG */}
              <svg viewBox="0 0 300 400" className="w-full h-full">
                <path d="M 75 50 L 120 30 Q 150 50 180 30 L 225 50 L 260 80 L 240 110 L 215 95 L 215 360 Q 150 380 85 360 L 85 95 L 60 110 L 40 80 Z"
                  fill="#0a0a0b" stroke="#00A86B" strokeWidth="2" />
              </svg>
            </div>
            {ZONES.map((z) => {
              const items = byZone(z.id);
              return (
                <div key={z.id}
                  data-testid={`jersey-zone-${z.id}`}
                  className="absolute border-2 border-dashed border-[#00A86B]/40 bg-[#00A86B]/5 rounded-md flex items-center justify-center text-center p-1"
                  style={{ left: z.x, top: z.y, width: z.w, height: z.h }}
                  title={z.note}
                >
                  <div className="text-[10px] uppercase tracking-widest text-[#00A86B]">
                    {z.label}<br />
                    <span className="text-zinc-400 normal-case tracking-normal text-[9px]">{items.length || 0} sponsor(s)</span>
                  </div>
                </div>
              );
            })}
          </div>
          {/* Legend */}
          <div className="space-y-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Sponsor Placement Matrix</div>
            {ZONES.map((z) => (
              <div key={z.id} className="p-3 rounded-lg bg-[#060d09] border border-white/10">
                <div className="flex items-baseline justify-between">
                  <div className="font-anton text-lg uppercase text-white">{z.label}</div>
                  <div className="text-[10px] uppercase tracking-widest text-zinc-500">{z.note}</div>
                </div>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {byZone(z.id).map((s) => (
                    <span key={s.id} className="text-xs px-2 py-1 bg-[#11241b] border border-white/10 rounded text-white">{s.name}</span>
                  ))}
                  {byZone(z.id).length === 0 && <span className="text-xs text-zinc-600">No sponsors assigned</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
}
